export default {
  el: '#nk6Report',
  data() {
    return {
      sections: [
        "section0",
        "section1",
        "section2",
        "section3",
        "section4",
        "section5",
      ],
      currentSection: "section0",
    };
  },
  mounted() {
    this.updateFooter();
  },
  methods: {
    openSection: function(event, section) {
      let el;
      if (event) {
        el = event.target;
        section = el.dataset.section;
      } else {
        el = document.querySelector(
          '#nk6Report li>a[data-section="' + section + '"]'
        );
      }

      let activeLink = document.querySelector("#nk6SectionsMenu a.active");
      let activeSection = document.querySelector("#nk6Report section.active");

      activeLink.classList.remove("active");
      activeLink.parentElement.classList.remove("active");
      el.classList.add("active");
      el.parentElement.classList.add("active");
      activeSection.classList.remove("active");
      document.querySelector("#" + section).classList.add("active");

      this.currentSection = section;
      this.updateFooter();
    },
    openNextSection: function(direction) {
      let currentSection = this.currentSection;

      if (direction > 0 && !this.checkSectionValidity(currentSection)) {
        document.getElementById(currentSection).classList.add("show-errors");
        return;
      }

      let index = this.sections.indexOf(currentSection);
      let newSection = this.sections[index + direction] ?? "end";

      if (newSection != "end") {
        this.openSection(null, newSection);
      } else {
        if (direction > 0) {
          //finish
          document.getElementById("nk6ReportForm").submit();
          window.setTimeout(function() {
            window.location.href = "/library/reports/nk6";
          }, 2000);
        } else {
          //first section reached
          return;
        }
      }
    },
    checkSectionValidity: function(section) {
      document.getElementById("nk6ReportForm").classList.remove("no-errors");
      if (!section) section = this.currentSection;
      let inputs = document.querySelectorAll(
        "#" + section + " input.form-control"
      );
      let invalid = document.querySelectorAll(
        "#" + section + " input.form-control:invalid"
      );

      inputs.forEach(function(el) {
        el.checkValidity();
      });

      return invalid.length == 0;
    },
    updateFooter: function() {
      let section = this.currentSection;

      if (section == "section0") {
        //hide back btn
        document.getElementById("nk6prev").classList.add("hidden");
      } else {
        document.getElementById("nk6prev").classList.remove("hidden");
      }

      let lastSection = this.sections[this.sections.length - 1];
      let nextBtn = document.getElementById("nk6next");
      let nextBtnHtml;
      if (section == lastSection) {
        nextBtnHtml = `Сформувати і завантажити звіт <i class="fas fa-download"></i>`;
      } else {
        nextBtnHtml = `Продовжити <i class="fas fa-arrow-circle-right"></i>`;
      }
      nextBtn.innerHTML = nextBtnHtml;
    },
    checkPrevData: function(e) {
      console.log(e);
      let currChilds = e.target.value;
      document.getElementById("nk6ReportForm").classList.add("no-errors");

      let formFields = document.querySelectorAll("#nk6ReportForm input");
      if (currChilds == 0) {
        formFields.forEach(function(field) {
          if (
            field.name != "_token" &&
            field.name != "year" &&
            field.name != "childs" &&
            field.name != "comment"
          )
            field.value = field.dataset["old"];
        });
      } else {
        formFields.forEach(function(field) {
          if (
            field.name != "_token" &&
            field.name != "year" &&
            field.name != "childs" &&
            field.name != "comment"
          )
            field.value = field.dataset["oldc"];
        });
      }
    },
  },
};
